import { z } from 'zod';
import { emailSchema, isoDateTimeSchema, localeSchema, ulidSchema } from '../common/primitives.js';
/**
 * Temporary compatibility shapes for the template web client.
 *
 * The API no longer has a password login: employees arrive through Unified
 * Access launch codes (`auth/contract.ts`). The web application still ships
 * the template's login screen until the POS shell and launch sign-in are
 * ported into `apps/web`. These schemas exist only so that code keeps
 * compiling in the meantime; nothing in the API uses them. Delete this file
 * together with the template login screen.
 */
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, 'password is required').max(128),
});
export const authTokensSchema = z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
    expiresIn: z.number().int().positive(),
    tokenType: z.literal('Bearer'),
});
export const userSchema = z.object({
    id: ulidSchema,
    email: emailSchema,
    fullName: z.string().min(1).max(120),
    role: z.string(),
    status: z.string(),
    locale: localeSchema,
    lastLoginAt: isoDateTimeSchema.nullable(),
    createdAt: isoDateTimeSchema,
    updatedAt: isoDateTimeSchema,
});
export const authSessionSchema = z.object({
    user: userSchema,
    tokens: authTokensSchema,
});
//# sourceMappingURL=template-web.js.map